/* eslint-disable react/display-name */
'use client';

import React from 'react';

import { mapModifiers } from '@/utils/funtion';
import dynamic from 'next/dynamic';
import Skeleton from '@/components/atoms/skeletons';

const SearchEngine = dynamic(
  () => import('@/components/templates/searchIEngine'),
  {
    ssr: false,
    loading: () => (
      <Skeleton
        active
        type="input"
        loading
        style={{ width: '70vw', height: 50 }}
      />
    ),
  },
);

interface HeaderProps {
  hasSearch?: boolean;
}

const BannerSearch: React.FC<HeaderProps> = React.memo(
  ({ hasSearch = true }) => {

    return (
      <div className={mapModifiers('o-banner-search')}>
        <div className="o-banner-search_wrapper">
          <div className="o-banner-search_search">
            <SearchEngine hasSelect/>
          </div>
        </div>
      </div>
    );
  },
);

export default BannerSearch;
